// src/data/regulatorDetails.js

export const regulatorDetails = {
  // ===========================
  // NURSING
  // ===========================

  CNO: {
    regulator: "College of Nurses of Ontario",
    abbreviation: "CNO",
    website: "https://www.cno.org",
    verificationUrl: "https://registry.cno.org/",
  },

  CRNA: {
    regulator: "College of Registered Nurses of Alberta",
    abbreviation: "CRNA",
    website: "https://nurses.ab.ca",
    verificationUrl: "https://myaccount.nurses.ab.ca/PublicRegistry/Search",
  },

  CLPNA: {
    regulator: "College of Licensed Practical Nurses of Alberta",
    abbreviation: "CLPNA",
    website: "https://www.clpna.com",
    verificationUrl: "https://www.clpna.com/",
  },

  CRPNA: {
    regulator: "College of Registered Psychiatric Nurses of Alberta",
    abbreviation: "CRPNA",
    website: "https://crpna.ab.ca",
    verificationUrl: "https://crpna.ab.ca/",
  },

  BCCNM: {
    regulator: "British Columbia College of Nurses and Midwives",
    abbreviation: "BCCNM",
    website: "https://www.bccnm.ca",
    verificationUrl: "https://registry.bccnm.ca/",
  },

  CRNS: {
    regulator: "College of Registered Nurses of Saskatchewan",
    abbreviation: "CRNS",
    website: "https://www.crns.ca",
    verificationUrl: "https://www.crns.ca/public-register/",
  },

  SALPN: {
    regulator: "Saskatchewan Association of Licensed Practical Nurses",
    abbreviation: "SALPN",
    website: "https://www.salpn.com",
    verificationUrl: "https://www.salpn.com/",
  },

  RPNAS: {
    regulator: "Registered Psychiatric Nurses Association of Saskatchewan",
    abbreviation: "RPNAS",
    website: "https://www.rpnas.com",
    verificationUrl: "https://www.rpnas.com/",
  },

  CRNM: {
    regulator: "College of Registered Nurses of Manitoba",
    abbreviation: "CRNM",
    website: "https://www.crnm.mb.ca",
    verificationUrl: "https://www.crnm.mb.ca/",
  },

  CLPNM: {
    regulator: "College of Licensed Practical Nurses of Manitoba",
    abbreviation: "CLPNM",
    website: "https://www.clpnm.ca",
    verificationUrl: "https://www.clpnm.ca/",
  },

  CRPNM: {
    regulator: "College of Registered Psychiatric Nurses of Manitoba",
    abbreviation: "CRPNM",
    website: "https://www.crpnm.mb.ca",
    verificationUrl: "https://www.crpnm.mb.ca/",
  },

  OIIQ: {
    regulator: "Ordre des infirmières et infirmiers du Québec",
    abbreviation: "OIIQ",
    website: "https://www.oiiq.org",
    verificationUrl: "https://www.oiiq.org/",
  },

  OIIAQ: {
    regulator: "Ordre des infirmières et infirmiers auxiliaires du Québec",
    abbreviation: "OIIAQ",
    website: "https://www.oiiaq.org",
    verificationUrl: "https://www.oiiaq.org/",
  },

  NANB: {
    regulator: "Nurses Association of New Brunswick",
    abbreviation: "NANB",
    website: "https://www.nanb.nb.ca",
    verificationUrl: "https://www.nanb.nb.ca/",
  },

  ANBLPN: {
    regulator: "Association of New Brunswick Licensed Practical Nurses",
    abbreviation: "ANBLPN",
    website: "https://www.anblpn.ca",
    verificationUrl: "https://www.anblpn.ca/",
  },

  NSCN: {
    regulator: "Nova Scotia College of Nursing",
    abbreviation: "NSCN",
    website: "https://www.nscn.ca",
    verificationUrl: "https://www.nscn.ca/public-resources/find-a-nurse",
  },

  CRNMPEI: {
    regulator: "College of Registered Nurses and Midwives of Prince Edward Island",
    abbreviation: "CRNMPEI",
    website: "https://crnpei.ca",
    verificationUrl: "https://crnpei.ca/",
  },

  CLPNPEI: {
    regulator: "College of Licensed Practical Nurses of Prince Edward Island",
    abbreviation: "CLPNPEI",
    website: "https://clpnpei.ca",
    verificationUrl: "https://clpnpei.ca/",
  },

  CRNNL: {
    regulator: "College of Registered Nurses of Newfoundland and Labrador",
    abbreviation: "CRNNL",
    website: "https://crnnl.ca",
    verificationUrl: "https://crnnl.ca/",
  },

  CLPNNL: {
    regulator: "College of Licensed Practical Nurses of Newfoundland and Labrador",
    abbreviation: "CLPNNL",
    website: "https://clpnnl.ca",
    verificationUrl: "https://clpnnl.ca/",
  },

  YRNA: {
    regulator: "Yukon Registered Nurses Association",
    abbreviation: "YRNA",
    website: "https://yrna.ca",
    verificationUrl: "https://yrna.ca/",
  },

  RNANTNU: {
    regulator: "Registered Nurses Association of the Northwest Territories and Nunavut",
    abbreviation: "RNANT/NU",
    website: "https://rnantnu.ca",
    verificationUrl: "https://rnantnu.ca/",
  },

  // Inside regulatorDetails.js

CLPHA: {
  regulator: "College of LPNs and HCAs of Alberta",
  abbreviation: "CLPNA",
  website: "https://www.clha.com",
  verificationUrl: "https://www.clha.com",
},

YUKON_PLA: {
  regulator:
    "Government of Yukon, Professional Licensing and Regulatory Affairs",
  abbreviation: "Yukon PLRA",
  website:
    "https://yukon.ca/en/doing-business/professional-licensing",
  verificationUrl:
    "https://yukon.ca/en/doing-business/professional-licensing",
},

GNWT_HSS: {
  regulator:
    "Government of the Northwest Territories, Professional Licensing, Health and Social Services",
  abbreviation: "GNWT HSS",
  website:
    "https://www.hss.gov.nt.ca/en/services/professional-licensing",
  verificationUrl:
    "https://www.hss.gov.nt.ca/en/services/professional-licensing",
},

NUNAVUT_HEALTH: {
  regulator: "Government of Nunavut, Department of Health",
  abbreviation: "Nunavut Health",
  website: "https://www.gov.nu.ca/health",
  verificationUrl: "https://www.gov.nu.ca/health",
},

  // ===========================
  // PHYSICIANS
  // ===========================

  CPSO: {
    regulator: "College of Physicians and Surgeons of Ontario",
    abbreviation: "CPSO",
    website: "https://www.cpso.on.ca",
    verificationUrl: "https://doctors.cpso.on.ca/",
  },

  CPSA: {
    regulator: "College of Physicians and Surgeons of Alberta",
    abbreviation: "CPSA",
    website: "https://cpsa.ca",
    verificationUrl: "https://search.cpsa.ca/",
  },

  CPSBC: {
    regulator: "College of Physicians and Surgeons of British Columbia",
    abbreviation: "CPSBC",
    website: "https://www.cpsbc.ca",
    verificationUrl: "https://www.cpsbc.ca/public/registrant-directory",
  },

  CPSS: {
    regulator: "College of Physicians and Surgeons of Saskatchewan",
    abbreviation: "CPSS",
    website: "https://www.cps.sk.ca",
    verificationUrl: "https://www.cps.sk.ca/",
  },

  CPSM: {
    regulator: "College of Physicians and Surgeons of Manitoba",
    abbreviation: "CPSM",
    website: "https://cpsm.mb.ca",
    verificationUrl: "https://cpsm.mb.ca/",
  },

  CMQ: {
    regulator: "Collège des médecins du Québec",
    abbreviation: "CMQ",
    website: "https://www.cmq.org",
    verificationUrl: "https://www.cmq.org/",
  }

  // Continue with:
  // Pharmacy
  // Dentistry
  // Respiratory Therapy
  // Laboratory
  // Imaging
  // Occupational Therapy
  // Physiotherapy
  // Speech-Language Pathology
  // Social Work
  // Dietetics
  // Paramedics
};